import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormAutocomplete, Modal } from "../../common";
import { Button, Row } from "../../App.styles";
import { Textarea } from "../../common/Textarea";

const AcceptModal = ({ onConfirm, onDismiss, currentPoints, defaultPoints, show }) => {
  const { t } = useTranslation();
  const [points, setPoints] = useState(currentPoints);
  const [message, setMessage] = useState("");
  const set = (setter) => {
    return (value) => {
        setter(value);
    }
  }

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Accept')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <Row>
          <FormAutocomplete 
            label={t("Points")} 
            value={points} 
            setValue={setPoints}
            stateful={false}
            options={Array(501)
                .fill()
                .map((_, i) => ({
                    id: i,
                    name: `${i} ${i === defaultPoints ? "*" : ""}`,
                }))}
            size="small"
            creatable
          />
        </Row>
        <Row className="mt-2">
          <Textarea
            placeholder={t("Message to player")}
            rows={5}
            value={message}
            onChange={set(setMessage)}
            mode="clean"
          />
        </Row>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t('Cancel')}
        </Button>
        <Button color="primary" onClick={() => onConfirm(points, message)}>
          {t('Accept')}
        </Button>
      </div>
    </Modal>
  );
};

export default AcceptModal;
